"use strict";
/* globals module */
/**
 * @module mediaVaultRoute
 * @description Baasic Media Vault Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var _1 = require("./");
var contracts_1 = require("../../core/contracts");
var MediaVaultRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultRoute, _super);
    function MediaVaultRoute(appOptions, mediaVaultStreamsRoute, mediaVaultBatchRoute, mediaVaultSettingsRoute, mediaVaultProcessingProviderSettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaVaultStreamsRoute = mediaVaultStreamsRoute;
        _this.mediaVaultBatchRoute = mediaVaultBatchRoute;
        _this.mediaVaultSettingsRoute = mediaVaultSettingsRoute;
        _this.mediaVaultProcessingProviderSettingsRoute = mediaVaultProcessingProviderSettingsRoute;
        _this.findRoute = 'media-vaults/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-vaults/{id}/{?embed,fields}';
        _this.updateRoute = 'media-vaults/{id}';
        _this.deleteRoute = 'media-vaults/{id}/{?height,width}';
        return _this;
    }
    Object.defineProperty(MediaVaultRoute.prototype, "streams", {
        get: function () {
            return this.mediaVaultStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "batch", {
        get: function () {
            return this.mediaVaultBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "settings", {
        get: function () {
            return this.mediaVaultSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "processingProviderSettings", {
        get: function () {
            return this.mediaVaultProcessingProviderSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media vault properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media vault subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media vault property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaVaultRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaVaultRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param id Media vault id which uniquely identifies media vault resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaVaultRoute.get({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param data Media vault object used to update specific Media vault resource in the system.
     * @example mediaVaultRoute.get({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param data Media vault object used to update specific Media vault resource in the system.
     * @param options Options object.
     * @example mediaVaultRoute.delete({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.delete = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data, options);
    };
    var _a, _b, _c, _d, _e;
    MediaVaultRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaVaultStreamsRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaVaultBatchRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MediaVaultSettingsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.MediaVaultProcessingProviderSettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaVaultStreamsRoute !== "undefined" && _1.MediaVaultStreamsRoute) === "function" ? _b : Object, typeof (_c = typeof _1.MediaVaultBatchRoute !== "undefined" && _1.MediaVaultBatchRoute) === "function" ? _c : Object, typeof (_d = typeof _1.MediaVaultSettingsRoute !== "undefined" && _1.MediaVaultSettingsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.MediaVaultProcessingProviderSettingsRoute !== "undefined" && _1.MediaVaultProcessingProviderSettingsRoute) === "function" ? _e : Object])
    ], MediaVaultRoute);
    return MediaVaultRoute;
}(common_1.BaseRoute));
exports.MediaVaultRoute = MediaVaultRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
